import React, { useEffect, useState } from 'react';
import { FiDownload } from 'react-icons/fi';
import UserVideos from '../UserVideos';
import { getRecentProjects, saveRecentProjects, removeRecentProject } from '../../utils/recentProjects';
import { getRequestStatus } from '../../api/shorts-api';
import './landing-v2.css';

// Renders below the upload tool on the v2 landing page:
//  - if the browser has saved projects → "Your recent shorts" (localStorage list)
//  - if not (new visitor / reviewer, no project created yet) → a prompt to download
//    a sample long-form video and try the tool.
// Clicking a card reopens that job via onVideoClick (the tool's handleRequestClick).
const RecentShortsStrip = ({ onVideoClick }) => {
    const [videos, setVideos] = useState(() => getRecentProjects());

    // On mount, refresh each saved project's live status and drop any that no
    // longer exist server-side, so the list stays accurate across sessions.
    useEffect(() => {
        let cancelled = false;
        const saved = getRecentProjects();
        if (!saved.length) return undefined;

        (async () => {
            const results = await Promise.all(
                saved.map(async (p) => {
                    try {
                        const req = await getRequestStatus(p.id);
                        if (req === undefined || req === null) return null; // deleted → drop
                        return { ...p, status: req.status || p.status };
                    } catch (e) {
                        return p; // keep last-known on transient errors
                    }
                })
            );
            if (cancelled) return;
            const next = results.filter(Boolean);
            saveRecentProjects(next);
            setVideos(next);
        })();

        return () => {
            cancelled = true;
        };
    }, []);

    // Empty state — no project has been created yet on this device: offer a sample video.
    if (!videos.length) {
        return (
            <section className="lp2-recent">
                <div className="lp2-recent-inner">
                    <div className="lp2-sample">
                        <div className="lp2-sample-text">
                            <h2>New here? Try it with a sample video</h2>
                            <p>
                                Download this sample long-form video, then drop it into the box above to
                                see Shorts Creator turn it into ready-to-post shorts.
                            </p>
                        </div>
                        <a
                            className="lp2-btn lp2-btn-primary lp2-sample-btn"
                            href="/sample_video.mp4"
                            download="sample_video.mp4"
                        >
                            <FiDownload /> Download sample video
                        </a>
                    </div>
                </div>
            </section>
        );
    }

    const handleDelete = (id) => setVideos(removeRecentProject(id));

    return (
        <section className="lp2-recent">
            <div className="lp2-recent-inner">
                <h2>Your recent shorts</h2>
                <p>Pick up where you left off — these are saved on this device.</p>
                <UserVideos videos={videos} onVideoClick={onVideoClick} onDeleteRequest={handleDelete} />
            </div>
        </section>
    );
};

export default RecentShortsStrip;
